import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private readonly defaultFontSize = 16;
  private readonly fontSizeStorageKey = 'mdg-app-font-size';

  // Usamos un BehaviorSubject para almacenar el valor actual
  private dataSidebar = new BehaviorSubject<boolean>(false);
  sidebarVisible = this.dataSidebar.asObservable();

  private fontSize = this.defaultFontSize;

  constructor() {
    this.loadFontSizePreference();
  }


  // Método para actualizar el valor
  visibleSidebar(data: boolean) {
    this.dataSidebar.next(data);
  }


  changeFontSize(amount: number): void {
    this.fontSize += amount;
    this.applyFontSize();
  }

  resetFontSize(): void {
    this.fontSize = this.defaultFontSize;
    this.applyFontSize();
  }

  private loadFontSizePreference(): void {
    if (typeof window === 'undefined') {
      return;
    }

    const storedFontSize = window.localStorage.getItem(this.fontSizeStorageKey);
    const parsedFontSize = Number(storedFontSize);

    if (Number.isFinite(parsedFontSize) && parsedFontSize > 0) {
      this.fontSize = parsedFontSize;
    }

    this.applyFontSize(false);
  }

  private applyFontSize(savePreference = true): void {
    if (typeof document !== 'undefined') {
      document.documentElement.style.setProperty('--app-font-size', `${this.fontSize}px`);
    }

    if (savePreference && typeof window !== 'undefined') {
      window.localStorage.setItem(this.fontSizeStorageKey, `${this.fontSize}`);
    }
  }
}
